




















































import {
    BButton,
    BCol,
    BContainer,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BInputGroup,
    BInputGroupAppend,
    BRow,
} from "bootstrap-vue";
import { ref, Ref } from "@vue/composition-api";
import { getRootDomain } from "@/utils/platforms";
import { isMobile } from "@/utils/mobile";
// @ts-ignore
import { getInstance } from "@/auth/auth0";
// @ts-ignore
import router from "@/router";
import useCustomer from "@/composables/v2.1/useCustomer";
import createAuth0Client from "@auth0/auth0-spa-js";
// @ts-ignore
import { ValidationObserver, ValidationProvider } from "vee-validate";
// @ts-ignore
import { required } from "@validations";

export default {
    components: {
        BButton,
        BCol,
        BContainer,
        BForm,
        BFormGroup,
        BFormInput,
        BImg,
        BInputGroup,
        BInputGroupAppend,
        BRow,
        ValidationObserver,
        ValidationProvider,
        required,
    },
    // @ts-ignore
    setup(_, { refs }) {
        // Mobile login leads to lifetime token, so you won't allow this for non-mobile.
        if (!isMobile()) {
            window.location.replace("https://saysimple.com");
        }

        const subdomain: Ref<string> = ref("");
        const invalidFeedback: Ref<string | null> = ref(null);

        const redirectToAuth0 = async (event: Event) => {
            event.preventDefault();
            invalidFeedback.value = null;

            localStorage.removeItem("mobileDomainOverride");

            refs.validationRules.validate().then(async (success: boolean) => {
                if (success) {
                    const domain = `${subdomain.value}.${getRootDomain()}`;

                    const { fetchOrgIdByDomain, customer } = useCustomer();
                    await fetchOrgIdByDomain(domain);

                    if (!customer.value.orgId) {
                        invalidFeedback.value = "invalid-domain";
                        return;
                    }

                    localStorage.setItem("mobileDomainOverride", domain);

                    // @NOTICE that this will redirect you to a different Auth0 "application" (client id) for mobile.
                    getInstance().auth0Client = await createAuth0Client({
                        domain: process.env.VUE_APP_AUTH0_DOMAIN as string,
                        client_id: process.env.VUE_APP_AUTH0_MOBILE_CLIENT_ID as string,
                        redirect_uri: window.location.origin,
                        organization: customer.value.orgId as string,
                    });

                    getInstance().auth0Client.loginWithRedirect();
                }
            });
        };

        return {
            redirectToAuth0,
            subdomain,
            invalidFeedback,
            saysimpleDomain: getRootDomain(),
        };
    },
};
